export default __webpack_public_path__ + "static/media/reset-wallpaper.ead5b950.png";